import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
`;

const Toggle = styled.div`
    display: inline-flex;
    background: #f1f5f9;
    border-radius: 10px;
    padding: 4px;
    gap: 2px;
`;

const Btn = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    border: none;
    border-radius: 7px;
    font-size: 0.875rem;
    font-weight: 600;
    font-family: "Inter", system-ui, sans-serif;
    cursor: pointer;
    transition: background 150ms, color 150ms, box-shadow 150ms;
    background: ${({ $active }) => $active ? "#ffffff" : "transparent"};
    color: ${({ $active }) => $active ? "#0f172a" : "#64748b"};
    box-shadow: ${({ $active }) => $active ? "0 1px 4px rgba(0,0,0,0.1)" : "none"};
    &:hover { color: #0f172a; }
`;

const Badge = styled.span`
    background: #6366f1;
    color: #fff;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 20px;
    letter-spacing: 0.3px;
`;

export const BillingIntervalButtons = ({ priceInterval, handlePriceIntervalChange }) => (
    <Wrap>
        <Toggle>
            <Btn $active={priceInterval === "month"} onClick={(e) => handlePriceIntervalChange(e, "month")}>
                Monthly
            </Btn>
            <Btn $active={priceInterval === "year"} onClick={(e) => handlePriceIntervalChange(e, "year")}>
                Annually <Badge>Save 20%</Badge>
            </Btn>
        </Toggle>
    </Wrap>
);
